// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
//MD5加密
import md5 from 'js-md5';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

//全局引入自定义组件
import '@/assets/css/reset.css';
import router from './router';
import store from './store';
import i18n from './i18n';
import bootstrap from './core';
import Http from './plugins/http.js';
import cusInstall from './plugins/cus-component';

import './router/permission';
import './utils/filter';
//引入ElBigdataTable 解决商户列表el-table数据量过大超过200条时 页面输入框及弹窗输入框输入非常卡顿的bug
import ElBigdataTable from 'vue-elementui-bigdata-table';
Vue.use(ElBigdataTable);
// 引用api文件
// import api from './api/index';
// Vue.prototype.$api = api;
import outToExcel from './utils/outToExcel';
import axios from 'axios';
import directives from '@/utils/directives';

Vue.prototype.outToExcels = outToExcel;
Vue.prototype.$http = Http;
Vue.prototype.$md5 = md5;
Vue.prototype.$defaultPaginationSize = 100;
Vue.prototype.keys = {
  current_user: {
    token: 'token',
    user: 'user',
    menus: []
  }
};
Vue.prototype.$getStatus = (list, code) => {
  if (!list) return '';
  let az = list.filter((it) => it.value == code);
  let [item] = az;
  return item ? item.label : '';
};
Vue.prototype.$axios = axios;
ElementUI.Dialog.props.closeOnClickModal.default = false;
Vue.use(ElementUI);
Vue.use(cusInstall);

// Vue.use(MyServerHttp);
Vue.config.productionTip = false;

if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
}

// 注册全局指令
Object.keys(directives).forEach((key) => {
  Vue.directive(key, directives[key]);
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  created: bootstrap,
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js